import React, { useState, useEffect } from 'react';
import './WorkareaProfile.css';
import ProfileCard from '../ProfileCard/ProfileCard';
import formatPhoneNumber from '../../utils/formatPhoneNumber';
import ProfileContainerContact from '../ProfileContainerContact/ProfileContainerContact';
import { updateUser } from '../../api/userDataApi';
import { useAuth } from '../../Context/AuthContext';
import { normalizeNumberForDataBase } from '../../utils/phone';

const WorkareaProfile = ({ profileData }) => {
  const initialFormData = { ...profileData, errors: {} }; // Объявляем начальное состояние формы
  const [formData, setFormData] = useState(initialFormData);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const { is_admin } = useAuth();

  useEffect(() => {
    const excludedFields = ['is_admin', 'errors']; // поля для исключения

    const stringifiedData = Object.fromEntries(
      Object.entries(profileData)
        .filter(([key]) => !excludedFields.includes(key)) // исключаем поля
        .map(([key, value]) => [key, value === null ? '' : String(value)])
    );

    setFormData({ ...stringifiedData, errors: {} });
  }, [profileData]);

  // Форматирование значений
  const formatFieldValue = (name, value, prevValue = '') => {
    switch (name) {
      case 'phone':
        return formatPhoneNumber(value, prevValue);
      default:
        return value;
    }
  };

  // Валидация
  const validateField = (name, value) => {
    let errorMessage = '';
    const digitsOnly = String(value).replace(/\D/g, '');

    switch (name) {
      case 'phone':
        if (digitsOnly.length < 11) {
          errorMessage = 'Номер телефона должен содержать 11 цифр';
        }
        break;
      default:
        break;
    }

    return errorMessage;
  };
  // Обработчик формы
  const handleChangeFormData = (name, value) => {
    setFormData((prev) => {
      const formattedValue = formatFieldValue(name, value, prev[name]);

      const updatedData = {
        ...prev,
        [name]: formattedValue,
      };

      const errorMessage = validateField(name, formattedValue);

      const updatedErrors = {
        ...prev.errors,
        [name]: errorMessage,
      };

      setIsFormChanged(
        JSON.stringify({ ...updatedData, errors: undefined }) !==
        JSON.stringify(profileData)
      );

      setIsFormValid(Object.values(updatedErrors).every((err) => !err));

      return {
        ...updatedData,
        errors: updatedErrors,
      };
    });
  };
  // Обновление данных профиля
  const handleDataProfileUpdate = () => {
    const { image, errors, uuid, phone, ...dataToSend } = formData;
    const normPhone = normalizeNumberForDataBase(phone);
    updateUser({
      ...dataToSend,
      phone: normPhone,
      id: uuid,
    })
      .then((res) => {
        console.log(res);
        setIsFormChanged(false);
      })
      .catch((err) => {
        console.log('Ошибка обновления данных пользователя', err);
      });
  };

  // Логика отмены ввода (возвращает данные к начальному состоянию)
  const handleCancel = () => {
    setFormData({ ...initialFormData, errors: {} });
    setIsFormChanged(false);
    setIsFormValid(true);
  };

  if (!profileData) return <p>Загрузка данных...</p>;

  return (
    <div className='workarea-profile'>
      <div className='workarea-profile__wrapper'>
        <section className='workarea-profile__left-section'>
          <ProfileCard isAdmin={is_admin} />
        </section>
        <section className='workarea-profile__right-section'>
          <ProfileContainerContact
            handleDataProfileUpdate={handleDataProfileUpdate}
            formData={formData}
            handleChangeFormData={handleChangeFormData}
            isFormChanged={isFormChanged}
            isFormValid={isFormValid}
            handleCancel={handleCancel} // Передаем обработчик отмены
          />
        </section>
      </div>
    </div>
  );
};

export default WorkareaProfile;
